"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.APOTEX_CUSTOM_FIELDS = void 0;
const types_1 = require("../custom-field-config/types");
exports.APOTEX_CUSTOM_FIELDS = [
    {
        name: 'shelfLife',
        label: 'shelf life',
        type: types_1.CustomFieldType.STRING,
        required: false,
    },
    {
        name: 'minShelfLife',
        label: 'minimum shelf life',
        type: types_1.CustomFieldType.STRING,
        required: false,
    },
    {
        name: 'leadTime',
        label: 'lead time',
        type: types_1.CustomFieldType.STRING,
        required: false,
    },
    {
        name: 'comments',
        label: 'comments',
        type: types_1.CustomFieldType.STRING,
        required: false,
    },
    {
        name: 'manufacturingSite',
        label: 'manufacturing site',
        type: types_1.CustomFieldType.STRING,
        required: false,
    },
    {
        name: 'barcode',
        label: 'barcode',
        type: types_1.CustomFieldType.STRING,
        required: false,
    },
    {
        name: 'serialized',
        label: 'serialized',
        type: types_1.CustomFieldType.STRING,
        required: false,
    },
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBvdGV4LWN1c3RvbS1maWVsZHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc3RhbnRzL2Fwb3RleC1jdXN0b20tZmllbGRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILDBEQUFpRTtBQTRCcEQsUUFBQSxvQkFBb0IsR0FBK0I7SUFDOUQ7UUFDRSxJQUFJLEVBQUUsV0FBVztRQUNqQixLQUFLLEVBQUUsWUFBWTtRQUNuQixJQUFJLEVBQUUsdUJBQWUsQ0FBQyxNQUFNO1FBQzVCLFFBQVEsRUFBRSxLQUFLO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsY0FBYztRQUNwQixLQUFLLEVBQUUsb0JBQW9CO1FBQzNCLElBQUksRUFBRSx1QkFBZSxDQUFDLE1BQU07UUFDNUIsUUFBUSxFQUFFLEtBQUs7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxVQUFVO1FBQ2hCLEtBQUssRUFBRSxXQUFXO1FBQ2xCLElBQUksRUFBRSx1QkFBZSxDQUFDLE1BQU07UUFDNUIsUUFBUSxFQUFFLEtBQUs7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxVQUFVO1FBQ2hCLEtBQUssRUFBRSxVQUFVO1FBQ2pCLElBQUksRUFBRSx1QkFBZSxDQUFDLE1BQU07UUFDNUIsUUFBUSxFQUFFLEtBQUs7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxtQkFBbUI7UUFDekIsS0FBSyxFQUFFLG9CQUFvQjtRQUMzQixJQUFJLEVBQUUsdUJBQWUsQ0FBQyxNQUFNO1FBQzVCLFFBQVEsRUFBRSxLQUFLO0tBQ2hCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsU0FBUztRQUNmLEtBQUssRUFBRSxTQUFTO1FBQ2hCLElBQUksRUFBRSx1QkFBZSxDQUFDLE1BQU07UUFDNUIsUUFBUSxFQUFFLEtBQUs7S0FDaEI7SUFDRDtRQUNFLElBQUksRUFBRSxZQUFZO1FBQ2xCLEtBQUssRUFBRSxZQUFZO1FBQ25CLElBQUksRUFBRSx1QkFBZSxDQUFDLE1BQU07UUFDNUIsUUFBUSxFQUFFLEtBQUs7S0FDaEI7Q0FDRixDQUFDIn0=